import * as angular from 'angular';
import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { IFoodPreference } from '../products/models/index';

export class FoodPreferenceService {
    static $inject = ['http', 'retailerService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService) {}

    getAllergens() {
        return this.http.get<IFoodPreference[]>( this.retailerService.foodAllergens());
    }

    getFoodPreference() {
        return this.http.get<IFoodPreference[]>( this.retailerService.foodPreference());
    }
}

angular.module('naut').service('foodPreferenceService', FoodPreferenceService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/foodPreferences/foodPreference.service.ts